import { REACT_QUERY_KEYS } from '@/constants'

export type TaxCategoriesSelectQueryParams = {
  tenantKey: string
  isActive?: boolean | undefined
}

export const taxCategoriesQueryKeys = {
  all: [REACT_QUERY_KEYS.TAX_CATEGORIES] as const,
  select: (params: TaxCategoriesSelectQueryParams) =>
    [...taxCategoriesQueryKeys.all, 'select', params] as const,
  detail: (tenantKey: string, taxCategoryId: number) =>
    [...taxCategoriesQueryKeys.all, 'detail', tenantKey, taxCategoryId] as const
}
